// Global
import React from 'react';

// Local
import { Content } from '@generated/Content/PreambleLinkList.model';
import { PreambleLinkList } from './PreambleLinkList';
import RichTextWrapper from 'components/helpers/SitecoreWrappers/RichTextWrapper/RichTextWrapper';
import { usePreambleFields } from 'components/helpers/Molecules/Preamble/Preamble.sitecore';
import { Themes } from 'lib/themes';
import { PreambleOrientation } from 'components/helpers/Molecules/Preamble/Preamble';
import { getComponentCss } from 'lib/utils/sitecore/component-css';
import useIsEditing from 'lib/hooks/sitecore/useIsEditing';

type PreambleLinkListProps = Content.PreambleLinkList.PreambleLinkList_Component;

export const Default = (props: PreambleLinkListProps) => {
  const isEditing = useIsEditing();

  const preambleFields = usePreambleFields({
    fields: props.fields,
    ctaComponentClassOverrides: {
      cta1: 'component-content-grid-color-button-color-1',
      cta2: 'component-content-grid-color-button-color-2',
    },
  });

  if (!props.fields) return <></>;

  const content = <RichTextWrapper field={props.fields?.content} />;

  const hasContent = !!props.fields?.content?.value;
  const hasPreambleContent = !!(
    preambleFields?.headlineEyebrow ||
    preambleFields?.headline ||
    preambleFields?.headlineSubhead ||
    preambleFields?.headlineDescription ||
    preambleFields?.cta1 ||
    preambleFields?.cta2
  );

  // Match Accordion behavior: in editing mode, always render so authors can edit.
  // Outside editing mode, don't render if it's entirely empty.
  if (!isEditing && !hasContent && !hasPreambleContent) return <></>;

  return (
    <PreambleLinkList
      className={getComponentCss(props)}
      theme={props.params?.theme as Themes}
      preamble={preambleFields}
      preambleOrientation={props.params?.preambleOrientation as PreambleOrientation}
      content={content}
    />
  );
};
